import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function TutorialImagePreviewModal({
  open,
  src,
  alt = '',
  onClose,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);

  if (!open || !src) return null;

  return createPortal(
    <div
      className="tutorial-image-preview"
      role="dialog"
      aria-modal="true"
      aria-label="图片预览"
      onClick={onClose}
    >
      <button
        type="button"
        className="tutorial-image-preview__close"
        aria-label="关闭预览"
        onClick={onClose}
      >
        <X size={22} />
      </button>
      <div
        className="tutorial-image-preview__body"
        onClick={(event) => event.stopPropagation()}
      >
        <img
          src={src}
          alt={alt}
          className="tutorial-image-preview__img"
          draggable={false}
        />
      </div>
    </div>,
    document.body,
  );
}
